import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import { BaseBackResponse } from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}quotes/created`;

export interface SubmitQuoteCommandArgs {
  quoteId: string;
}

export const submitQuoteRequest = (
  payload: SubmitQuoteCommandArgs,
): ApiRequestDescriptor => ({
  url: ENDPOINT,
  config: {
    method: SUPPORTED_METHODS.POST,
    json: { quoteId: payload.quoteId, comment: '' },
  },
});

export const submitQuoteCommand = async (
  payload: SubmitQuoteCommandArgs,
): Promise<BaseBackResponse> => {
  try {
    return await executeQuery<BaseBackResponse>(submitQuoteRequest(payload));
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
